module.exports = __webpack_public_path__ + "static/img/track-productivity.fe38d52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/track-productivity.svg
// module id = Scyg
// module chunks = 1